import { FC } from "react"

import { RISK_LEVEL_CONFIG } from "components/risk/constants"

interface Props {
  level: number
  count: number
  total: number
}

export const RiskLevelCard: FC<Props> = ({ level, count, total }) => {
  const cfg = RISK_LEVEL_CONFIG[level]
  const percentage = total > 0 ? ((count / total) * 100).toFixed(1) : "0"

  return (
    <div className="bg-white dark:bg-[#131421] border border-gray-200 dark:border-[rgba(255,255,255,0.1)] shadow-sm dark:shadow-none rounded-xl p-5 transition-colors">
      <div className="flex justify-between items-start mb-3">
        <div>
          <p className="text-sm text-gray-400 dark:text-gray-500">Level {level}</p>
          <p className="text-2xl font-bold">{count.toLocaleString()}</p>
        </div>
        <span className={`badge ${cfg.badgeClass} badge-sm`}>{cfg.label}</span>
      </div>
      <p className="text-sm text-gray-400 dark:text-gray-500">{percentage}% of total</p>
    </div>
  )
}
